var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound",attrs:{"id":"notfound"}},[_vm._v(" Not Found ")])
}
var staticRenderFns = []

export { render, staticRenderFns }